import script from "./PgmEmployees.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgmEmployees.vue?vue&type=script&setup=true&lang=ts"

import "./PgmEmployees.vue?vue&type=style&index=0&id=57d5884d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57d5884d"]])

export default __exports__